// SHADOW MARKET™ — Kids progress (localStorage, no backend, kid-privacy-safe).
const KEY = "rebel_kids_progress";

const load = () => {
  try {
    return JSON.parse(window.localStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
};

export const getKidsProgress = () => load();

export const getKidsStars = (leccionId) => {
  const p = load();
  return p[leccionId]?.stars || 0;
};

export const isLeccionCompleted = (leccionId) => {
  const p = load();
  return !!p[leccionId]?.completed;
};

export const setLeccionCompleted = (leccionId, stars = 1) => {
  const p = load();
  const prev = p[leccionId] || { stars: 0, completed: false };
  p[leccionId] = {
    completed: true,
    stars: Math.max(prev.stars, Math.min(3, stars)),
    last: new Date().toISOString(),
  };
  try {
    window.localStorage.setItem(KEY, JSON.stringify(p));
  } catch {}
  return p[leccionId];
};

export const resetKidsProgress = () => {
  try {
    window.localStorage.removeItem(KEY);
  } catch {}
};

// Map mini-game score → stars (0-3).
export const scoreToStars = (score) => {
  if (score >= 80) return 3;
  if (score >= 40) return 2;
  if (score > 0) return 1;
  return 1; // baseline for completing the lesson
};
